module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.accesses.title')))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fetchFilters": _vm.fetchFilters,
      "fields": _vm.fields,
      "filtering": false,
      "exportable": false,
      "editable": false,
      "deletable": false,
      "default-order": "actionDate",
      "default-order-asc": false,
      "perPage": 10
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82c179ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Accesses.vue
// module id = 1090
// module chunks = 1